import { render, staticRenderFns } from "./privacyPolicySummary.vue?vue&type=template&id=4045a424&scoped=true"
import script from "./privacyPolicySummary.vue?vue&type=script&lang=js"
export * from "./privacyPolicySummary.vue?vue&type=script&lang=js"
import style0 from "./privacyPolicySummary.vue?vue&type=style&index=0&id=4045a424&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045a424",
  null
  
)

export default component.exports